export default __webpack_public_path__ + "static/media/Onetowinlogo.eaa15f47.png";